import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router';
import { needsNoAuth } from './utils/authHoc';
import isEmail from 'validator/lib/isEmail';
import { Translate } from 'react-redux-i18n';
import {
  register as actionRegister,
  registerWithToken as actionRegisterWithToken,
  checkEmail as actionCheckEmail,
  auth as actionAuth,
} from '../actions/auth';
import { trackYandexGoal, addMarketingFlags } from '../actions/utils';
import CheckBox from './utils/CheckBox';

/*
 *  Register form page
 */

class RegisterForm extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.register = this.register.bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.validatePhone = this.validatePhone.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleShowPassword = this.handleShowPassword.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.handleSendEmails = this.handleSendEmails.bind(this);

    this.state = {
      email: '',
      phone: '',
      realname: '',
      password: '',
      showPassword: false,
      sendEmails: true,
      buttonDisabled: false,

      emailValid: false,
      emailChecked: false,
      phoneValid: false,
      passwordValid: false,
      highlightInvalid: false,
    };
  }

  toggleDisabled() {
    const { buttonDisabled } = this.state;
    this.setState({ buttonDisabled: !buttonDisabled });
    if (!buttonDisabled) this.timer = setTimeout(this.toggleDisabled, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  register(e) {
    const {
      emailValid,
      emailChecked,
      passwordValid,
      email,
      password,
      phone,
      realname,
      sendEmails,
    } = this.state;

    e.preventDefault();
    if (!phone || !emailValid || !emailChecked || !passwordValid) {
      this.setState({ highlightInvalid: true });
      return true;
    }

    trackYandexGoal('registration');
    if (typeof fbq !== 'undefined') {
      // eslint-disable-next-line no-undef
      fbq('track', 'CompleteRegistration');
    }

    this.toggleDisabled();
    this.props.register(
      email,
      phone,
      realname,
      password,
      this.props.school,
      sendEmails,
      this.props.language,
      this.props.invite
    );
    this.setState({
      email: '',
      emailChecked: false,
      phone: '',
      realname: '',
      password: '',
      sendEmails: true,
      showPassword: false,
    });
    return false;
  }

  handleEmailChange(event) {
    const email = event.target.value;
    if (email !== '') {
      this.setState({ email, emailValid: true });
    } else {
      this.setState({ email, emailValid: true, emailChecked: false });
    }
  }

  validateEmail() {
    const { email } = this.state;
    const emailValid = isEmail(email);

    if (emailValid) {
      this.props.checkEmail(email, () => this.setState({ emailChecked: true }));
    }

    this.setState({ emailValid });
  }

  handlePhoneChange(event) {
    let phone = event.target.value;
    this.setState({ phone, phoneValid: true });
  }

  validatePhone() {
    this.setState({ phoneValid: !!this.state.phone });
  }

  handleNameChange(event) {
    const name = event.target.value;
    this.setState({ realname: name });
  }

  handlePasswordChange(event) {
    const password = event.target.value;
    this.setState({ password, passwordValid: true });
  }

  handleShowPassword(showPassword) {
    this.setState({ showPassword });
  }

  validatePassword() {
    const { password } = this.state;
    let passwordValid = false;

    if (password.length >= 8) {
      passwordValid = true;
    }
    this.setState({ passwordValid });
  }

  handleSendEmails(sendEmails) {
    this.setState({ sendEmails });
  }

  render() {
    const {
      email,
      phone,
      realname,
      password,
      showPassword,
      emailValid,
      emailChecked,
      phoneValid,
      passwordValid,
      sendEmails,
      highlightInvalid,
    } = this.state;

    const { emailFree } = this.props;

    let emailClass = '';
    let emailMessage = '';
    if (email || highlightInvalid) {
      emailClass =
        emailValid && (emailFree || !emailChecked)
          ? 'has-success'
          : 'has-error';
      if (emailChecked && emailValid && !emailFree) {
        emailMessage = <Translate value="register.errors.email.taken" />;
      } else if (!emailValid) {
        emailMessage = <Translate value="register.errors.email.wrong" />;
      }
    }

    let phoneClass = '';
    let phoneValidMessage = '';
    if (phone || highlightInvalid) {
      if (phoneValid) phoneClass = 'has-success';
      else {
        phoneClass = 'has-error';
        phoneValidMessage = (
          <Translate value="register.errors.phone.incorrect" />
        );
      }
    }

    let passwordClass = '';
    let passwordValidMessage = '';
    if (password || highlightInvalid) {
      if (passwordValid) passwordClass = 'has-success';
      else {
        passwordClass = 'has-error';
        passwordValidMessage = (
          <Translate value="register.errors.password.length" />
        );
      }
    }

    return (
      <form className="row form-padding text-left">
        <div className={`${emailClass}`}>
          <label htmlFor="email-input" className="input-label">
            <Translate value="placeholder.email" />
          </label>
          <input
            id="email-input"
            type="email"
            className="form-control"
            autoComplete="new-password"
            value={email}
            onChange={this.handleEmailChange}
            onBlur={this.validateEmail}
          />
          <span className="help-block">{emailMessage}</span>
        </div>

        <div className={`${passwordClass}`}>
          <label htmlFor="password-input" className="input-label">
            <Translate value="placeholder.password" />
          </label>
          <input
            id="password-input"
            type={showPassword ? 'text' : 'password'}
            className="form-control"
            autoComplete="new-password"
            value={password}
            onChange={this.handlePasswordChange}
            onBlur={this.validatePassword}
          />
          <span className="help-block">{passwordValidMessage}</span>
        </div>

        <div className="form-group">
          <CheckBox onChange={this.handleShowPassword} checked={showPassword}>
            <Translate className="text-muted" value="register.showpassword" />
          </CheckBox>
        </div>

        <div>
          <label htmlFor="name-input" className="input-label">
            <Translate value="placeholder.name" />
          </label>
          <input
            id="name-input"
            type="text"
            className="form-control"
            autoComplete="new-password"
            value={realname}
            onChange={this.handleNameChange}
          />
          <span className="help-block" />
        </div>

        <div className={`${phoneClass}`}>
          <label htmlFor="phone-input" className="input-label">
            <Translate value="placeholder.phone" />
          </label>
          <input
            id="phone-input"
            type="tel"
            className="form-control"
            autoComplete="tel"
            value={phone}
            onChange={this.handlePhoneChange}
            onBlur={this.validatePhone}
          />
          <span className="help-block">{phoneValidMessage}</span>
        </div>

        <div className="form-group">
          <CheckBox onChange={this.handleSendEmails} checked={sendEmails}>
            <Translate className="text-muted" value="register.personal.email" />
          </CheckBox>
        </div>

        <button
          type="submit"
          className={`btn btn-lg btn-block btn-orange btn-medium text-uppercase`}
          onClick={this.register}
          disabled={this.state.buttonDisabled}
        >
          <Translate value="register.signup" />
        </button>
      </form>
    );
  }
}

class AuthForm extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.login = this.login.bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);

    this.state = {
      email: '',
      password: '',
      highlightInvalid: false,
    };
  }

  login(e) {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ highlightInvalid: true });
      return true;
    }

    trackYandexGoal('auth');

    this.props.auth(email, password);
    return false;
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  render() {
    const { email, password, highlightInvalid } = this.state;

    let emailClass = '';
    let emailMessage = '';
    if (!email && highlightInvalid) {
      emailClass = 'has-error';
      emailMessage = <Translate value="auth.requiredField" />;
    }

    let passwordClass = '';
    let passwordMessage = '';
    if (!password && highlightInvalid) {
      passwordClass = 'has-error';
      passwordMessage = <Translate value="auth.requiredField" />;
    }

    return (
      <form className="row form-padding text-left">
        <div className={`${emailClass}`}>
          <label htmlFor="email-input" className="input-label">
            <Translate value="placeholder.email" />
          </label>
          <input
            id="email-input"
            type="email"
            className="form-control"
            autoComplete="email"
            value={this.state.email}
            onChange={this.handleEmailChange}
          />
          <span className="help-block">{emailMessage}</span>
        </div>

        <div className={`${passwordClass}`}>
          <label htmlFor="password-input" className="input-label">
            <Translate value="placeholder.password" />
          </label>
          <input
            id="password-input"
            type="password"
            className="form-control"
            autoComplete="current-password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
          />
          <span className="help-block">{passwordMessage}</span>
        </div>

        <button
          type="submit"
          className="btn btn-medium btn-dark-green btn-block text-uppercase"
          onClick={this.login}
        >
          <Translate value="auth.login" />
        </button>

        <div className="row text-center">
          <Link to="/i/reset" className="btn-text" style={{ margin: '30px 0' }}>
            <Translate className="text-muted" value="auth.reset.forgot" />
          </Link>
        </div>
      </form>
    );
  }
}

class Register extends React.PureComponent {
  constructor(props) {
    super(props);

    this.authSocial = this.authSocial.bind(this);
  }

  componentDidMount() {
    const {
      params: { token, flag },
      language,
    } = this.props;
    if (token) this.props.registerWithToken(token, language);
    if (flag) addMarketingFlags([flag]);
  }

  authSocial(provider) {
    trackYandexGoal('auth-' + provider);
    return true;
  }

  render() {
    const { school, language, invite } = this.props;

    return (
      <div className="container-fluid centered-flex auth bg-light_green">
        <div className="container text-center with-robot-head">
          <div className="row block-lg bg-white center-block">
            <div className="robot-head">
              <img
                className={school ? 'school-logo' : ''}
                src={require(`../assets/images/${
                  school ? `schools/${school}.png` : 'robot-head.svg'
                }`)}
                alt="progkids-green-robot"
              />
            </div>

            <div className="row row-flex">
              <div className="col-xs-12 col-sm-6 form-group">
                <div className="row">
                  <h1 className="text-header">
                    <Translate value="register.access" />
                  </h1>
                </div>

                <RegisterForm
                  emailFree={this.props.emailFree}
                  register={this.props.register}
                  checkEmail={this.props.checkEmail}
                  school={school}
                  language={language}
                  invite={invite}
                />
              </div>

              <div className="col-xs-12 col-sm-6 form-group with-vr">
                <div className="row">
                  <h1 className="text-header">
                    <Translate value="register.hasAccount" />
                  </h1>
                </div>

                <AuthForm auth={this.props.auth} />
              </div>
            </div>

            <div
              className="col-xs-12 footer text-muted"
              style={{ marginBottom: '1em', marginTop: '1em' }}
            >
              <p className="text-center">
                <Translate value="register.personal.data" />
              </p>
              <p className="text-center">
                <Translate className="text-green" value="inTouch" />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Register.propTypes = {
  emailFree: PropTypes.bool.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    emailFree: state.register.emailFree,
    school: ownProps.params.school,
    invite: ownProps.params.invite,
    language: state.i18n.locale,
  };
}

const mapDispatchToProps = dispatch => ({
  checkEmail: (email, callback) => dispatch(actionCheckEmail(email, callback)),
  register: (
    email,
    phone,
    realname,
    password,
    school,
    sendEmails,
    language,
    invite
  ) =>
    dispatch(
      actionRegister(
        email,
        phone,
        realname,
        password,
        school,
        sendEmails,
        language,
        invite
      )
    ),
  registerWithToken: (token, language) =>
    dispatch(actionRegisterWithToken(token, language)),
  auth: (email, password) => dispatch(actionAuth(email, password)),
});

export default compose(
  needsNoAuth,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Register);
